import React from "react";

export const EditorDirty = React.createContext<(value: boolean) => void>(null);

export function useSetDirty(): any {
  return React.useContext(EditorDirty);
}
